import {
  Accordion,
  AspectRatio,
  Blockquote,
  Box,
  Button,
  Card,
  Container,
  Image,
  List,
  rem,
  rgba,
  SimpleGrid,
  Space,
  Stack,
  Text
} from "@mantine/core"
import { Trans, useTranslation } from "react-i18next"
import ReactPlayer from "react-player/file"

import { range } from "@mantine/hooks"
import { IconInfoCircle } from "@tabler/icons-react"
import { renderFooter } from "../Commons/Renders"

export function Home(): React.ReactElement {
  const { i18n, t } = useTranslation()

  return (
    <Box>
      <Container>
        <Stack gap={rem(48)} style={{ flex: 1 }}>
          <Text fz={rem(20)} fw={500}>
            <Trans i18nKey={"heroTitle"} components={{ br: <br /> }} />
          </Text>

          <Space h={rem(4)} />

          <SimpleGrid cols={{ base: 1, md: 2, lg: 2 }} spacing={rem(8)} mx={"auto"}>
            <Stack align={"flex-start"} justify="center">
              <Image
                w={96}
                h={96}
                src={"/images/aurora_store.webp"}
                aria-label="img-aurora-store"
                alt="img-aurora-store"
              />
              <Text fz={rem(20)}>
                <Trans i18nKey={"introText01"} components={{ br: <br /> }} />
              </Text>
              <Text fz={rem(20)}>
                <Trans i18nKey={"introText02"} components={{ br: <br /> }} />
              </Text>
              <Text fz={rem(20)}>
                <Trans i18nKey={"introText03"} components={{ br: <br /> }} />
              </Text>
            </Stack>

            <AspectRatio ratio={3 / 4} maw={480}>
              <Image src={"/images/store_banner.webp"} aria-label="hero-img-store" alt="hero-img-store" />
            </AspectRatio>
          </SimpleGrid>
        </Stack>
      </Container>

      <Space h={rem(48)} />

      <Container>
        <Stack>
          <Card w={"auto"} radius="md" withBorder shadow="sm">
            <Card.Section>
              <AspectRatio ratio={16 / 9}>
                <ReactPlayer
                  key={"video"}
                  url={`https://auroraoss.com/resources/videos/${i18n.language}.mp4`}
                  playing={false}
                  pip={true}
                  controls={true}
                  loop={false}
                  width={"100%"}
                  height={"auto"}
                />
              </AspectRatio>
            </Card.Section>
            <Stack align={"flex-start"} p={"md"}>
              <Text fz={rem(24)} fw={500}>
                {t("howToTitle")}
              </Text>
              <List type="ordered" spacing="md">
                <Trans i18nKey={"howToText"} components={{ br: <br />, li: <List.Item></List.Item> }} />
              </List>
            </Stack>
            <Card.Section withBorder inheritPadding py="md">
              <Button
                fullWidth
                size="md"
                color={rgba("#CF0A2C", 0.9)}
                onClick={() => {
                  window.open("https://appgallery.huawei.com/app/C110907863")
                }}
              >
                {t("howToButton")}
              </Button>
            </Card.Section>
          </Card>
        </Stack>
      </Container>

      <Space h={rem(48)} />

      <Container>
        <Stack gap={rem(48)}>
          <Box>
            <Text fz={rem(24)} fw={500}>
              {t("FAQTitle")}
            </Text>
            <Space h={rem(16)} />
            <Accordion variant={"contained"} transitionDuration={320} w={"auto"}>
              {range(1, 6).map((item) => (
                <Accordion.Item key={item} value={`question-${item}`}>
                  <Accordion.Control>
                    <Text>{t(`FAQQuestion0${item}`)}</Text>
                  </Accordion.Control>
                  <Accordion.Panel fw={300}>{t(`FAQAnswer0${item}`)}</Accordion.Panel>
                </Accordion.Item>
              ))}
            </Accordion>
          </Box>

          <Blockquote
            color={"primary"}
            opacity={0.7}
            style={{ textAlign: "justify" }}
            icon={<IconInfoCircle size={24} />}
          >
            {t("smallPrint")}
          </Blockquote>
        </Stack>
      </Container>

      <Space h={rem(48)} />

      {renderFooter()}
    </Box>
  )
}
